// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router/index";
import utils from "@/util/util.js"; //引入公共的方法
Vue.prototype.utils = utils; //原型指向该方法



import store from "./vuex/store"; // 引入store
//view ui
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
Vue.use(ViewUI);
//view ui
//个性化组件引用
import plugins from "./util/person";
Vue.use(plugins)
//个性化结束
//个性化组件引用
import city from "./util/city";
Vue.prototype.city = city;
//个性化结束

//个性化组件引用
import diction from "./util/diction";
Vue.prototype.lydic = diction;
//个性化结束
import '../config/axios'
import axios from "axios";
Vue.prototype.axios = axios;

import echarts from "echarts";
Vue.prototype.echarts = echarts
//另一个图片查看器
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})



import "../config/has"
import 'babel-polyfill' //ie问题 npm install babel-polyfill --save-dev
//请求拦截器
import '../config/axios'

//语言包
import VueI18n from "vue-i18n"
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'zh-CN',
  messages: {
    'zh-CN': require('./components/lang/zh'),
  }
})

//语言包结束
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  router,
  store,
  components: { App },
  template: "<App/>"
});






// WEBPACK FOOTER //
// ./src/main.js